import { TipoDirittoReale } from '../tipologiche/tipo-diritto-reale';

export class DatiCatastaliBase {
  id: string;
  sezione: string;
  foglio: string;
  particella: string;
  subParticella: string;
  subalterno: string;
  subalterno2: string;
  graffato: string;
  classe: number;
  tipoDirittoReale: TipoDirittoReale;
  quota: any;
}
